<template>
  <DetailsPane
    :title="title || 'Company Details'"
    :hide-title="hideTitle"
    :hide-close="hideClose"
    :height="height"
    :auto-height="autoHeight"
    @close="$emit('close')"
  >
    <div class="details-pane-table p-4">
      <div class="row mb-2">
        <div class="col-4 col-attribute">Company Name:</div>
        <div class="col-8 col-value">{{ company.name }}</div>
      </div>
      <div v-if="!!company.hvac_id" class="row mb-2">
        <div class="col-4 col-attribute">HVAC ID:</div>
        <div class="col-8 col-value">{{ company.hvac_id }}</div>
      </div>
      <div v-if="section === 'admin'" class="row mb-2">
        <div class="col-4 col-attribute">Company Type:</div>
        <div class="col-8 col-value">{{ company.type }}</div>
      </div>
      <div v-else-if="!!company.aviator_id" class="row mb-2">
        <div class="col-4 col-attribute">Aviator ID:</div>
        <div class="col-8 col-value">{{ company.aviator_id }}</div>
      </div>
      <div v-else class="row mb-2">
        <div class="col-4 col-attribute">MLC ID:</div>
        <div class="col-8 col-value">{{ company.id }}</div>
      </div>
        <div class="row mb-2" v-if="company.le_distributors">
            <div class="col-4 col-attribute">LE Distributor(s):</div>
            <div class="col-8 col-value" v-html="company.le_distributors.join(`<br />`)"></div>
        </div>
      <div class="row mb-2">
        <div class="col-4 col-attribute">Brand:</div>
        <div class="col-8 col-value">{{ company.brand }}</div>
      </div>
      <div v-if="!!company.fad_brand" class="row mb-2">
        <div class="col-4 col-attribute">FAD/Elite Brand:</div>
        <div class="col-8 col-value">{{ company.fad_brand }}</div>
      </div>
      <div v-if="parentInfo && $root.isAdmin">
        <div v-for="(parent, brand) in company.parent_info" :key="parent.id"  class="row mb-2">
          <div class="col-4 col-attribute">{{ brand }} Distributor:</div>
          <div class="col-8 col-value">{{ parent.name}} ({{ parent.hvac_id }})</div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-4 col-attribute">Phone:</div>
        <div class="col-8 col-value">{{ company.phone }}</div>
      </div>
      <div class="row mb-2">
        <div class="col-4 col-attribute">Fax:</div>
        <div class="col-8 col-value">{{ company.fax }}</div>
      </div>
      <div class="row mb-2">
        <div class="col-4 col-attribute">Address:</div>
        <div class="col-8 col-value" v-html="company.address"></div>
      </div>
      <template v-if="showFullDetails">
        <div v-if="!!company.locator_brand" class="row mb-2">
          <div class="col-4 col-attribute">Locator Brand:</div>
          <div class="col-8 col-value">{{ company.locator_brand }}</div>
        </div>
        <div v-if="!!company.sap_sell_to" class="row mb-2">
          <div class="col-4 col-attribute">SAP Sell To:</div>
          <div class="col-8 col-value">{{ company.sap_sell_to }}</div>
        </div>
        <div v-if="!!company.sap_ship_to" class="row mb-2">
          <div class="col-4 col-attribute">SAP Ship To:</div>
          <div class="col-8 col-value">{{ company.sap_ship_to }}</div>
        </div>
      </template>
      <div v-if="!hideDetailsButton" class="row pt-4">
        <div class="col-12 text-center">
          <a :href="detailsUrl" class="btn btn-info">{{ detailsLabel }}</a>
        </div>
      </div>
    </div>
  </DetailsPane>
</template>

<script>
import DetailsPane from "components/listings/DetailsPane";
import DetailsPaneMixin from "mixins/DetailsPane";
export default {
  mixins: [DetailsPaneMixin],
  components: { DetailsPane },
  props: {
    company: { type: Object, required: true },
    section: { type: String, default: "training" },
    hideDetailsButton: { type: Boolean, default: false },
    showFullDetails: { type: Boolean, default: false },
  },
  computed: {
    detailsUrl() {
      return this.section == "admin" && !!this.company.can_update
        ? this.route("admin.companies.edit", { company: this.company.id })
        : this.route("training.companies.show", { company: this.company.id });
    },
    detailsLabel() {
      return this.section == "admin" && !!this.company.can_update
        ? "Edit Company"
        : "View Full Details";
    },
    parentInfo() {
      return !_.isEmpty(this.company.parent_info);
    }
  },
};
</script>
